export default "__VITE_ASSET__TwCiGVGl__"